namespace Roodik.Game
{
	import ITileModel = Roodik.Game.ITileModel;
	import NeighborKey = Roodik.Game.NeighborKey;
	
	export class SolvableStrategy implements IShuffleStrategy
	{
		private _countAttempt:number = 0;
		private _internalColumns:Array<string>;
		
		constructor(private _columns : Array<string>,
		            private _tiles : Array<ITileModel>)
		{}
		
		private createColumns()
		{
			this._internalColumns = new Array<string>();
			let keys = Object.keys(this._columns);
			for(let key of keys)
			{
				this._internalColumns[key] = this._columns[key];
			}
		}
		
		public shuffle()
		{
			this.createColumns();
			
			let tileInfo:Array<TileInfo> = this.getPairedList();
			let solvableTiles:Array<TileInfo> = new Array<TileInfo>();
			let counterForStartFromBegin:number = 0;
			this._countAttempt = 0;
			
			while(this.canDoReshuffle())
			{
				for(var i : number = 0; i < tileInfo.length; i++)
				{
					let j = Math.round(Math.random() * (tileInfo.length - 1));
					while(i == j)
					{
						j = Math.round(Math.random() * (tileInfo.length - 1));
					}
					
					var tempIType = tileInfo[i].type;
					var tempIDesc = tileInfo[i].description;
					var tempISound = tileInfo[i].sound;
					
					var tempJType = tileInfo[j].type;
					var tempJDesc = tileInfo[j].description;
					var tempJSound = tileInfo[j].sound;
					
					tileInfo[i].changeTileInfo(tempJType, tempJDesc, tempJSound);
					tileInfo[j].changeTileInfo(tempIType, tempIDesc, tempISound);
				}
				
				solvableTiles = solvableTiles.concat(this.getTilesWhichCanBeMatched(tileInfo));

				if (counterForStartFromBegin >= 100)
				{
					this._countAttempt++;
					this.createColumns();
					tileInfo = this.getPairedList();
					solvableTiles = new Array<TileInfo>();
					counterForStartFromBegin = 0;
				}
				counterForStartFromBegin++;
			}
			
			for (let solvableIndex:number = 0; solvableIndex < solvableTiles.length; solvableIndex++)
			{
				let solvableTile = solvableTiles[solvableIndex];
				let realTile = this.getElementByKey(solvableTile.key);
				realTile.changeTileInfo(solvableTile.type,solvableTile.description,solvableTile.sound);
			}
		}
		
		private canDoReshuffle()
		{
			return this.hasTiles() && this._countAttempt<=10;
		}
		
		private getElementByKey(key : string) : ITileModel
		{
			for(var i : number = 0; i < this._tiles.length; i++)
			{
				if(this._tiles[i].key == key)
				{
					return this._tiles[i];
				}
			}
		}
		
		private hasTiles()
		{
			let keys = Object.keys(this._internalColumns);
			for(let key of keys)
			{
				if (this._internalColumns[key] == "1")
				{
					return true;
				}
			}
			return false;
		}
		
		private getPairedList() : Array<TileInfo>
		{
			let list = [];
			for(var i : number = 0; i < this._tiles.length; i++)
			{
				if(this._tiles[i] != null && !this._tiles[i].removed)
				{
					let tile : ITileModel = this._tiles[i];
					let tileInfo = new TileInfo(tile.key, tile.type, tile.description, tile.sound);
					list.push(tileInfo);
				}
			}
			
			return list;
		}
		
		private getTilesWhichCanBeMatched(tiles:Array<TileInfo>) : Array<TileInfo>
		{
			let canMatchTiles : Array<TileInfo> = [];
			var tilesCount : number = tiles.length;
			for(var i = 0; i < (tilesCount - 1); i++)
			{
				for(var j = i + 1; j < tilesCount; j++)
				{
					if(tiles[i] != null && tiles[j] != null &&
					!tiles[i].placed && !tiles[j].placed)
					{
						if(tiles[i].type == tiles[j].type)
						{
							if(this.tileCanSelect(tiles[i]) && this.tileCanSelect(tiles[j]))
							{
								this._internalColumns[tiles[i].key] = "0";
								this._internalColumns[tiles[j].key] = "0";
								canMatchTiles.push(tiles[i]);
								canMatchTiles.push(tiles[j]);
								
								tiles[i].placed = true;
								tiles[j].placed = true;
							}
						}
					}
				}
			}


			for (let sortedIndex:number = 0; sortedIndex < canMatchTiles.length; sortedIndex++)
			{
				for (let originIndex:number = 0; originIndex < tiles.length; originIndex++)
				{
					if (canMatchTiles[sortedIndex].key == tiles[originIndex].key)
					{
						tiles.splice(originIndex,1);
						break;
					}
				}
			}
			
			return canMatchTiles;
		}
		
		private tileCanSelect(tile : TileInfo) : Boolean
		{
			if(this.neighborExist(NeighborKey.UP, tile.key))
			{
				return false;
			}
			
			return (!this.neighborExist(NeighborKey.LEFT, tile.key) || !this.neighborExist(NeighborKey.RIGHT, tile.key));
		}
		
		private neighborExist(neighborKey : NeighborKey, key : string) : Boolean
		{
			let arr = key.split(":");
			let _x : number = +arr[0];
			let _y : number = +arr[1];
			let _z : number = +arr[2];
			
			switch(neighborKey)
			{
				case NeighborKey.DOWN:
					return this._internalColumns[_x + ":" + _y + ":" + (_z - 1)] == "1";
				case NeighborKey.UP:
					return this._internalColumns[_x + ":" + _y + ":" + (_z + 1)] == "1";
				case NeighborKey.RIGHT:
					return this._internalColumns[(_x + 1) + ":" + _y + ":" + _z] == "1";
				case NeighborKey.LEFT:
					return this._internalColumns[(_x - 1) + ":" + _y + ":" + _z] == "1";
			}
			return false;
		}
	}
	
	export class TileInfo
	{
		constructor(private _key : string,
		            private _type : string,
		            private _description : string,
		            private _sound : string)
		{
		}
		
		public changeTileInfo(type : string, desc:string, sound:string)
		{
			this._type = type;
			this._description = desc;
			this._sound = sound;
		}
		
		public placed : boolean;
		
		public get key() : string {return this._key;}
		
		public get type() : string {return this._type;}
		
		public get description() : string {return this._description;}
		
		public get sound() : string {return this._sound;}
		
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/Reshuffle/SolvableStrategy.ts